// MR 22SEP26 Migrate host application to Native Federation with remoteName resolution
import { initFederation } from '@angular-architects/native-federation';

initFederation()
  .catch(err => console.error('Native Federation init error:', err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error('App bootstrap error:', err));

